module.exports = __webpack_public_path__ + "media/heal_effect.24339cc4.mp3";